<template>
  <footer>
    <div class="inner">
      <div class="top">
        <div class="leftContents">
          <div class="btImgBox">
            <img
              style="width: 28rem; height: auto"
              src="../../assets/images/footer/agetech_platform-logo-white.png"
              alt="logo_white img"
            />
          </div>
          <div class="corpCon">
            <h6>
              (17104) 경기도 용인시 기흥구 덕영대로 1732 경희대학교 | TEL.
              031-201-2955 | E-MAIL.seniorbiz@khu.ac.kr
            </h6>
            <h6>
              AgeTech Platform . 경희대학교 AgeTech연구소 . ALL RIGHTS
              RESERVED.
            </h6>
            <h6>
              운영기관: 경희대학교 동서의학대학원 AgeTech연구소, SSK
              뉴에이징 사업단
            </h6>
            <h6>후원기관: 한국연구재단, 한국보건산업진흥원</h6>
          </div>
        </div>
        <div class="rightContents">
          <nav class="btGnb">
            <ul
              v-show="
                isAuth && getUser != null && getUser.roleName == $role.ADMIN
              "
              class="adminFooterMenu"
            >
              <li>
                <h6><strong>플랫폼 소개</strong></h6>
                <ul>
                  <li>
                    <a href="/newAgingPlatform" target="_blank"
                      ><h6>AgeTech Platform</h6></a
                    >
                  </li>
                  <li>
                    <a href="/globalTrend" target="_blank"
                      ><h6>시니어산업 글로벌 트렌드</h6></a
                    >
                  </li>
                </ul>
              </li>
              <li>
                <h6><strong>서비스 소개</strong></h6>
                <ul>
                  <li>
                    <a href="/corpNetworking" target="_blank"
                      ><h6>기업 네트워킹</h6></a
                    >
                  </li>
                  <li>
                    <a href="/olderConsumers" target="_blank"
                      ><h6>고령 소비자</h6></a
                    >
                  </li>
                  <li>
                    <a
                      href="https://newagingplatform.com/about/service"
                      target="_blank"
                      ><h6>교육·정보 제공</h6></a
                    >
                  </li>
                </ul>
              </li>
              <li>
                <h6><strong>커뮤니티</strong></h6>
                <ul>
                  <li>
                    <a href="/notice" target="_blank"><h6>공지사항</h6></a>
                  </li>
                  <li>
                    <a href="/faq" target="_blank"><h6>FAQ</h6></a>
                  </li>
                  <li>
                    <a href="/QnA" target="_blank"><h6>1:1 문의</h6></a>
                  </li>
                </ul>
              </li>
            </ul>
            <ul
              v-show="
                getUser == null ||
                  (getUser != null && getUser.roleName != $role.ADMIN)
              "
              class="footerMenu"
            >
              <li
                v-for="(item, index) in items"
                :key="index"
                :class="[item.dropClass, item.mobileMenu]"
              >
                <p>{{ item.title }}</p>
                <ul>
                  <li
                    v-for="(subItem, index) in item.sub"
                    :key="index"
                    v-show="!subItem.forTopMenu"
                  >
                    <router-link :to="subItem.link">{{
                      subItem.title
                    }}</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <div class="ftLoginBtn">
            <a v-if="isAuth" @click="onClickSignout"><h6>로그아웃</h6></a>
            <router-link v-else to="/auth"
              ><h6><strong>로그인</strong></h6></router-link
            >
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="btTop">
          <div
            class="left adminFooterMenu"
            v-show="
              isAuth && getUser != null && getUser.roleName == $role.ADMIN
            "
          >
            <router-link to="/auth/privacyForm"
              ><h6><strong>개인정보처리방침</strong></h6></router-link
            >
            <router-link to="/auth/noEmail"
              ><h6><strong>이메일 무단수집거부</strong></h6></router-link
            >
          </div>
          <div
            class="left"
            v-show="
              getUser == null ||
                (getUser != null && getUser.roleName != $role.ADMIN)
            "
          >
            <router-link to="/auth/privacyForm"
              ><h6><strong>개인정보처리방침</strong></h6></router-link
            >
            <router-link to="/auth/noEmail"
              ><h6><strong>이메일 무단수집거부</strong></h6></router-link
            >
          </div>
          <div class="right">
            <div>
              <a href="http://gsm.khu.ac.kr/" target="_blank"
                ><img
                  src="../../assets/images/footer/footer_img1.png"
                  alt="경희대 로고"
              /></a>
              <a href="https://www.nrf.re.kr/index" target="_blank"
                ><img
                  src="../../assets/images/footer/footer_img3.png"
                  alt="한국연구제단 로고"
              /></a>
              <a href="https://www.khidi.or.kr/kps" target="_blank"
                ><img
                  src="../../assets/images/footer/footer_img2.png"
                  alt="한국보건산업진흥원 로고"
              /></a>
            </div>
          </div>
        </div>
        <div class="btBottom">
          <h6>ⓒ 2021 newagingplatform Co,.Ltd. All right reserved.</h6>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
//import { mapGetters, mapActions } from 'vuex'
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as jwtUtil from "@/utils/jwtUtil";
import { MENU_ITEMS } from "@/data/header";

export default {
  data() {
    return {
      isShowSub: false,
      isShowProfile: false,
      isActive: false,
      isShowMobileMenu: false,
      isShowSubMobileMenu: false,
      temp: 0,
      isSubHidden: false,
    };
  },
  watch: {
    $route(to) {
      var self = this;

      if (to.fullPath === "/") {
        self.currentItem = null;
        self.currentSubItem = null;
      } else {
        for (var i = 0; i < self.items?.length; i++) {
          var item = self.items[i];
          var found = false;

          if (item.link === to.fullPath) {
            self.currentItem = item;
            self.currentSubItem = null;
            found = true;
          }

          for (var j = 0; j < item.sub?.length; j++) {
            var subItem = item.sub[j];
            if (subItem.link === to.fullPath) {
              self.currentItem = item;
              self.currentSubItem = subItem;
              found = true;
              break;
            }
          }

          if (found) break;
        }
      }
    },
  },
  computed: {
    ...mapGetters("header", ["getCurrentItem", "getCurrentSubItem"]),
    ...mapGetters("auth", ["isAuth", "getUser"]),
    currentItem: {
      get() {
        return this.getCurrentItem;
      },
      set(value) {
        this.setCurrentItem(value);
      },
    },
    currentSubItem: {
      get() {
        return this.getCurrentSubItem;
      },
      set(value) {
        this.setCurrentSubItem(value);
      },
    },
    items() {
      if (this.isAuth == true && this.getUser != null) {
        switch (this.getUser.roleName) {
          case this.$role.USER:
            return MENU_ITEMS.COMMON_FOOTER_MENU_ITEMS;
          case this.$role.CORP:
            return MENU_ITEMS.COMMON_FOOTER_MENU_ITEMS;
          case this.$role.ADMIN:
            return MENU_ITEMS.COMMON_FOOTER_MENU_ITEMS;
        }
      }

      return MENU_ITEMS.COMMON_FOOTER_MENU_ITEMS;
    },
    isSelected(item) {
      if (this.currentSubItem.link === item.link) {
        return item.topClass;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapMutations("header", ["setCurrentItem", "setCurrentSubItem"]),
    ...mapActions("auth", ["signout"]),
    onClickSignout() {
      var refreshToken = localStorage.getItem(
        jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
      );
      var user = this.getUser;
      var userIdx = 0;
      if (user != null) {
        userIdx = user.idx;
      }

      this.signout({
        userIdx: userIdx,
        refreshToken: refreshToken,
      }).then(() => {
        this.$alert("알림", "로그아웃 되었습니다.", "확인", {
          closed: () => {
            this.$router.replace({ path: "/" });
          },
        });
      });
    },
  },
};
</script>

<style></style>
